//@flow

import { Link } from "gatsby";
import React from "react";

import ArrowForwardIcon from "@/images/ArrowForward.inline.svg";
import { classNameOf } from "@/utils";

export type Variant = "boxed-light" | "boxed-light-gray" | "light" | "dark";

type Props = {
    to?: string,
    variant: Variant,
    children?: React$Node,
    styles?: string,
    target?: string,
    icon?: React$Node,
};

const ContinueLink = ({to, children, variant, styles, target, icon}: Props): React$Element<'div' | 'a'> => {
    const Tag = to === undefined ? "div" : Link;

    return (
        <Tag
            to={to}
            className={classNameOf("continue-link", variant, styles || "")}
            target={target ?? "_self"}
        >
            {children}

            {icon ? (
                <div className="pl-3">{icon}</div>
            ) : (
                <div className="svg-box icon-sm transition icon-forward">
                    <div className="svg-container">
                        <ArrowForwardIcon />
                    </div>
                </div>
            )}
        </Tag>
    );
};

export default ContinueLink;
